// @ts-check
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import {
  ARTICLE_IDS,
  TRACKING as TRACKING_EVENTS
} from 'common/constants/constants';
import * as LighthouseService from 'common/services/lighthouse.service';
import AppRouter from 'common/AppRouter';
import { useHistory } from 'react-router';
import { BookDemoTooltip } from '@linearb/linui-common';
import {
  CTA_TOOLTIP_TEXTS,
  TRACKING
} from '../../../dashboard/doraV2/dashboard.doraV2.freeTier.consts';
import useDoraFeatureFlags from 'views/root/views/home/hooks/useDoraFeatureFlags';
import { navigateBookDemoClick } from 'common/utils/utils';
import * as TrackingService from 'common/services/tracking.service';
import { LBButton } from '@linearb/buzz';

const Container = styled(Flex)`
  background-color: ${getColor('zircon')};
  border-radius: 0.6rem;
`;

const ConnectSlackCTA = () => {
  const history = useHistory();
  const { isAllControbutorsTeamSelected } = useDoraFeatureFlags();

  const clickAndTrackBookDemo = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CTA_CLICK, {
      page: TRACKING_EVENTS.PAGES.SETTINGS,
      cta: TRACKING.CTA_TYPE.BUTTON,
      intent: TRACKING.CTA_INTENT.BOOK_A_DEMO,
      source_url: window.location.href
    });
    navigateBookDemoClick();
  };

  const bookDemoTooltipProps = {
    message: CTA_TOOLTIP_TEXTS.NOTIFICATIONS,
    buttonText: CTA_TOOLTIP_TEXTS.BOOK_A_DEMO,
    onClick: clickAndTrackBookDemo,
    disabled: !isAllControbutorsTeamSelected
  };
  return (
    <Container
      justify='center'
      items='center'
      pt='x-x-small'
      pb='x-x-small'
      pr='small'
      pl='small'
    >
      <Text color='shuttleGray' size='medium' pr='1rem'>
        Prepare for the meeting with our Slack Daily Digest:
      </Text>
      <div className='flex flex-row gap-2'>
        <BookDemoTooltip {...bookDemoTooltipProps}>
          <div>
            <LBButton
              variant='outline'
              size='sm'
              onClick={() =>
                history.push({
                  pathname: AppRouter.SLACK.path,
                  search: 'isOrgSettings=true'
                })
              }
              disabled={isAllControbutorsTeamSelected}
            >
              Connect Slack
            </LBButton>
          </div>
        </BookDemoTooltip>

        <LBButton
          size='sm'
          variant='ghost'
          onClick={() =>
            LighthouseService.navigateArticle(ARTICLE_IDS.CONNECT_SLACK)
          }
        >
          Learn more
        </LBButton>
      </div>
    </Container>
  );
};
export default ConnectSlackCTA;
